import z from 'zod';

import { socialApiClient } from '@/shared/api-client/social-api-client';
import { getCurrentDiscoverySession, type DiscoverySession } from './get-current-discovery-session';

export const createDiscoverySessionResponseSchema = z.object({
  session_id: z.string(),
});

export type CreateDiscoverySessionResponse = z.infer<typeof createDiscoverySessionResponseSchema>;

export async function createDiscoverySession(
  workspaceId: string,
  signal?: AbortSignal,
): Promise<DiscoverySession | null> {
  await socialApiClient.post(`workspaces/${workspaceId}/discovery-session`, {
    signal,
  });

  const newSession = await getCurrentDiscoverySession(workspaceId);

  return newSession;
}
